module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 512 209.4",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }